/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BbsContentCreateReqVo
 */
export interface BbsContentCreateReqVo {
    /**
     * 韩文名字，必传
     * @type {string}
     * @memberof BbsContentCreateReqVo
     */
    nameKr: string;
    /**
     * 中文名字，必传
     * @type {string}
     * @memberof BbsContentCreateReqVo
     */
    nameCn: string;
    /**
     * 韩文内容，必传
     * @type {string}
     * @memberof BbsContentCreateReqVo
     */
    contentKr: string;
    /**
     * 中文内容，必传
     * @type {string}
     * @memberof BbsContentCreateReqVo
     */
    contentCn: string;
    /**
     * 分类 ID，关联 BBS 分类表，必传
     * @type {number}
     * @memberof BbsContentCreateReqVo
     */
    categoryId: number;
    /**
     * 作者(中文)，必传
     * @type {string}
     * @memberof BbsContentCreateReqVo
     */
    authorCn: string;
    /**
     * 作者(韩文)，必传
     * @type {string}
     * @memberof BbsContentCreateReqVo
     */
    authorKr: string;
    /**
     * 发布时间，必传
     * @type {string}
     * @memberof BbsContentCreateReqVo
     */
    publishTime: string;
    /**
     * 是否可用：0-不可用，1-可用，默认可用，必传
     * @type {number}
     * @memberof BbsContentCreateReqVo
     */
    enable: number;
    /**
     * 是否置顶：0-不置顶，1-置顶，默认不置顶，必传
     * @type {number}
     * @memberof BbsContentCreateReqVo
     */
    top: number;
    /**
     * 排序序号：置顶优先，同置顶/非置顶内按序号升序，序号相同按发布时间倒序，默认1
     * @type {number}
     * @memberof BbsContentCreateReqVo
     */
    sort: number;
}

/**
 * Check if a given object implements the BbsContentCreateReqVo interface.
 */
export function instanceOfBbsContentCreateReqVo(value: object): value is BbsContentCreateReqVo {
    if (!('nameKr' in value) || value['nameKr'] === undefined) return false;
    if (!('nameCn' in value) || value['nameCn'] === undefined) return false;
    if (!('contentKr' in value) || value['contentKr'] === undefined) return false;
    if (!('contentCn' in value) || value['contentCn'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('authorCn' in value) || value['authorCn'] === undefined) return false;
    if (!('authorKr' in value) || value['authorKr'] === undefined) return false;
    if (!('publishTime' in value) || value['publishTime'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('top' in value) || value['top'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    return true;
}

export function BbsContentCreateReqVoFromJSON(json: any): BbsContentCreateReqVo {
    return BbsContentCreateReqVoFromJSONTyped(json, false);
}

export function BbsContentCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BbsContentCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'nameKr': json['nameKr'],
        'nameCn': json['nameCn'],
        'contentKr': json['contentKr'],
        'contentCn': json['contentCn'],
        'categoryId': json['categoryId'],
        'authorCn': json['authorCn'],
        'authorKr': json['authorKr'],
        'publishTime': json['publishTime'],
        'enable': json['enable'],
        'top': json['top'],
        'sort': json['sort'],
    };
}

export function BbsContentCreateReqVoToJSON(json: any): BbsContentCreateReqVo {
    return BbsContentCreateReqVoToJSONTyped(json, false);
}

export function BbsContentCreateReqVoToJSONTyped(value?: BbsContentCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nameKr': value['nameKr'],
        'nameCn': value['nameCn'],
        'contentKr': value['contentKr'],
        'contentCn': value['contentCn'],
        'categoryId': value['categoryId'],
        'authorCn': value['authorCn'],
        'authorKr': value['authorKr'],
        'publishTime': value['publishTime'],
        'enable': value['enable'],
        'top': value['top'],
        'sort': value['sort'],
    };
}

